<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-monitoring-viatic-approve"
      title="VIATIC APPROVE"
      modal-class="modal-warning"
      hide-footer
      @hidden="$emit('hideModal')"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="mb-1 mt-1">
        <b-row>
          <b-col sm="6">
            <b-input-group class="mb-1">
              <template #prepend>
                <b-input-group-text class="prepend__width">
                  <strong>CODE</strong>
                </b-input-group-text>
              </template>
              <b-form-input :value="dataModal.code" disabled />
            </b-input-group>
          </b-col>
          <b-col sm="6">
            <b-input-group class="mb-1">
              <template #prepend>
                <b-input-group-text class="prepend__width">
                  <strong>NAME</strong>
                </b-input-group-text>
              </template>
              <b-form-input :value="dataModal.personal_name" disabled />
            </b-input-group>
          </b-col>
        </b-row>
      </div>

      <div class="scroll-kanban">
        <b-row>
          <b-col sm="12">
            <b-form-checkbox
              checked="true"
              v-model="form.is_pay"
              class="custom-control-success"
              name="check-button"
              switch
            >
              <span style="font-size: 14px">
                Generar pago de S/. {{ form.viatic_amount | currency }}
              </span>
            </b-form-checkbox>
          </b-col>
        </b-row>

        <h4 class="mt-2 p-0" v-if="form.is_pay">Resumen de Pago</h4>
        <hr v-if="form.is_pay" />
        <b-table-simple
          v-if="form.is_pay"
          bordered
          small
          caption-top
          responsive
          ref="table_payment_viatic_detail"
          class="custom-table"
          cellspacing="0"
          cellpadding="0"
        >
          <b-tbody>
            <b-tr>
              <b-th style="font-size: 14px" class="text-center">Dia</b-th>
              <!-- <b-th style="font-size: 14px" class="text-center">Viatic.</b-th> -->
              <b-th style="font-size: 14px" class="text-center">Asist.</b-th>
              <b-th style="font-size: 14px" class="text-center">Monto</b-th>
              <b-th style="font-size: 14px" class="text-center"
                >Observacion</b-th
              >
            </b-tr>
            <b-tr
              v-for="(item, index) in JSON.parse(dataModal.attend_ids)"
              :key="index"
            >
              <b-td class="text-center">
                <span class="alignTitle"> {{ item.key }} </span>
              </b-td>
              <!-- <b-td class="text-center">
                <b-badge
                  pill
                  :variant="`light-${
                    item.is_viatic == 1 ? 'success' : 'danger'
                  }`"
                >
                  <span>{{ item.is_viatic == 1 ? "Apply" : "No Apply" }}</span>
                </b-badge>
              </b-td> -->
              <b-td class="text-center">
                <span class="cursor-pointer">
                  <b-avatar
                    rounded
                    size="sm"
                    :variant="resolvColor(item.homework_status_id)"
                  >
                    <span>
                      {{ item.abbreviation }}
                    </span>
                  </b-avatar>
                </span>
              </b-td>
              <b-td class="text-center">
                <span> S/ {{ item.viatic_cost | currency }} </span>
              </b-td>
              <b-td>
                <span>{{ item.observation }} </span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
      <div class="text-center mt-2">
        <b-button @click="saveApproveViatic" variant="outline-warning"
          >Approve</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import { mapGetters } from "vuex";
import modalMixin from "@/mixins/modal";
import AttendanceService from "@/views/monitoring/views/attendance/services/attendance.service.js";
import viaticService from "@/views/monitoring/views/viatic/services/viatic.service.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  mixins: [modalMixin],
  components: {
    flatPickr,
  },
  props: {
    dataModal: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      homeworkStatuses: [],
      form: {
        attendance_id: this.dataModal.id,
        user_id: null,
        viatic_amount: this.dataModal.viatic_amount,
        is_viatic: this.dataModal.is_viatic,
        is_pay: this.dataModal.is_viatic == "Not Apply" ? false : true,
        attend_ids: this.dataModal.attend_ids,
      },
      disabled: false,
    };
  },
  mounted() {
    this.toggleModal("modal-monitoring-viatic-approve");
  },
  async created() {},
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  methods: {
    async saveApproveViatic() {
      try {
        const confirm = await this.showConfirmSwal();

        if (confirm.isConfirmed) {
          this.addPreloader();
          this.form.user_id = this.currentUser.id;
          const { data } = await viaticService.saveApproveViatic(this.form);
          if (data[0].type == "success") {
            if (this.form.is_pay || this.form.amount > 0) {
              const params = {
                user_id: this.currentUser.id,
                start_date: this.dataModal.start_date,
                end_date: this.dataModal.end_date,
                is_generate_payment: true,
                amount: this.form.viatic_amount,
                personal_id: this.dataModal.personal_id,
                personal_name: this.dataModal.personal_name,
                token: "sfgdshfiuhfgsd7w9t874w9erfhu54k435df",
              };
              const form_params = new URLSearchParams();
              form_params.append("data", JSON.stringify(params));
              const data2 = await viaticService.createCaja(form_params);
            }
            this.$toast({
              component: ToastificationContent,
              position: "top-center",
              props: {
                title: "Success",
                icon: "CoffeeIcon",
                variant: "success",
                text: "Approved Viatic.",
              },
            });
            this.$emit("hideModal", true);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    resolvColor(homework_status_id) {
      if (homework_status_id == null) return "light-warning";
      switch (homework_status_id) {
        case 1:
          return "light-primary";
          break;
        case 2:
          return "light-success";
          break;
        case 3:
          return "light-danger";
          break;
        default:
          return "light-info";
          break;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>